import {management} from '../../../../index.js' //api

async function getVolumesInInterval({ FK_VALVE, FK_SECTOR, START, END}) {
  const raw = `
    SELECT *
    FROM CROP.VOLUME
    WHERE (
      TIME BETWEEN '${START}' AND '${END}'
      AND FK_VALVE = ${FK_VALVE}
      AND FK_SECTOR = ${FK_SECTOR}
    );
  `;

  const resp = await management.sql({
    data: {
      sql: raw
    }
  })
  .then(resp => resp && resp[0] ? resp[0] : [])
  .catch(err => {
    console.log(err)
    return [];
  })

  return resp
}

export {
  getVolumesInInterval
};